import { css as i } from "@microsoft/fast-element";
import { normalize as l } from "../common/normalize.js";
import { display as c, PropertyStyleSheetBehavior as s } from "@matrix42/fast-foundation";
import { designTokens as o } from "../design-tokens.js";
import { typography as a } from "../styles/typography.js";
function t(r, n) {
  return new s("color", r, n);
}
function e(r) {
  return i`
    .control {
      /* Style */
      border-radius: ${o.spacing["0.5"]}
        ${o.spacing["0.5"]} 0 0;
      border-bottom: ${o.borderWidth.xs} solid
        ${o.color[r][100]};
      color: ${o.color[r][100]};
    }

    .control:hover {
      /* Style */
      border-bottom: ${o.borderWidth.sm} solid
        ${o.color[r][200]};
      background-color: ${o.color[r][40]};
      color: ${o.color[r][200]};
      margin-bottom: calc(-1 * ${o.borderWidth.xs});
    }

    .control:focus-visible {
      /* Style */
      border-bottom: ${o.borderWidth.sm} solid
        ${o.color[r][500]};
      background-color: ${o.color[r][40]};
      color: ${o.color[r][200]};
    }

    .control:active {
      /* Style */
      border-bottom-color: ${o.color[r][500]};
      background-color: ${o.color[r][500]};
      color: ${o.color.white};
    }
  `;
}
const g = (r) => i`
    ${l}
    ${c("inline-flex")}
    .control {
      /* Base */
      text-decoration: none;
      cursor: pointer;
      /* Layout */
      padding: calc(0.5 * ${o.spacing["0.5"]})
        ${o.spacing["0.5"]} 0 ${o.spacing["0.5"]};
      /* Typography */
      ${a("p", "semibold", !0)};
    }

    .control:focus-visible {
      /* Base */
      outline: none;
    }

    ::slotted(${r.prefix}-icon) {
      /* Style */
      color: inherit;
    }
  `.withBehaviors(
  t("highlight", e("primary")),
  t("neutral", e("neutral")),
  t("warning", e("warning")),
  t("error", e("error"))
);
export {
  g as linkStyles
};
